const IMAGE_SIZE = 256;

export function getStationDescription(station, reviews, fuels, amenities) {
  const { address, name, star_rating: rating } = station;
  let stationDescription = `${name} in ${address.locality}, ${address.region}.`;

  stationDescription += ` Carries ${fuels.reduce(
    (prev, curr) => ([...prev, curr.displayName]), [],
  ).join(', ')}.`;

  if (amenities.length) {
    stationDescription += ` Has ${amenities.reduce(
      (prev, curr) => ([...prev, curr.displayName]), [],
    ).join(', ')}.`;
  }

  stationDescription += ' Check current gas prices and read customer reviews.';

  // Our rating is valid as long as we have at least 1 review and our rating is properly defined
  if (rating !== undefined && reviews.length) {
    stationDescription += ` Rated ${rating} out of 5 stars.`;
  }

  return stationDescription;
}

export function generateStationSchema({ station, reviews, fuels, amenities, hours }) {
  const schema = {
    '@type': 'GasStation',
    name: station.name,
    geo: {
      '@type': 'GeoCoordinates',
      latitude: station.latitude,
      longitude: station.longitude,
    },
    address: {
      streetAddress: station.address.line_1,
      addressLocality: station.address.locality,
      addressRegion: station.address.region,
      postalCode: station.address.postal_code,
      country: station.address.country,
      telephone: station.phone,
    },
    image: `https://images.gasbuddy.com/di/b/1/${station.brandId}.png?w=${IMAGE_SIZE}`,
    description: getStationDescription(station, reviews, fuels, amenities),
    openingHours: hours && hours.opening_hours,
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: station.star_rating || 0,
      ratingCount: station.ratings_count || 0,
      reviewCount: station.reviewCount || undefined, // reviewCount must be positive, so make it undefined if it isn't
      bestRating: 5,
      worstRating: 1,
    },
    review: reviews.map(review => (
      {
        '@context': 'http://schema.org',
        '@type': 'Review',
        datePublished: review.date,
        author: {
          '@type': 'Person',
          name: review.user.name,
          image: review.user.avatarUrl,
        },
        reviewBody: review.content,
      }
    )),
  };

  // ratingCount must be positive, so if we don't have one, or it is 0, do not report an aggregateRating or review for this station
  if (schema.aggregateRating.ratingCount < 1) {
    delete schema.aggregateRating;
    delete schema.review;
  }

  return schema;
}
